import a from 'axios'
import config from '@/config'
const token = localStorage.getItem('token')
a.defaults.headers.common = { Authorization: `Bearer ${token}` }
const headers = {
  'Content-Type': 'application/json'
}

const prefixEndpoint = config.apiBaseUrl

export default {
  getIntegrationServicesList() {
    return a.get(prefixEndpoint + 'integration/servicelist', headers)
  },
  getAllSyncs() {
    return a.get(prefixEndpoint + 'integration/list', headers)
  },
  getInfo(payload) {
    return a.post(prefixEndpoint + `integration/${payload.system}/info`, payload.data, headers)
  },
  setConnection(payload) {
    return a.post(prefixEndpoint + `integration/${payload.system}/create`, payload.data, headers)
  },
  setSyncMode(payload) {
    return a.post(prefixEndpoint + 'integration/syncmode', payload.data, headers)
  },
  testConnection(payload) {
    return a.post(prefixEndpoint + `integration/${payload.system}/test`, payload.data, headers)
  },
  oAuthConfirm(payload) {
    return a.post(prefixEndpoint + `integration/oauth/${payload.system}`, payload.data, headers)
  },
  synchronize(payload) {
    return a.post(prefixEndpoint + `integration/${payload.system}/synchronize`, payload.data, headers)
  },
  deleteIntegration(payload) {
    return a.post(prefixEndpoint + 'integration/delete', payload, headers)
  },
  getLogs(payload) {
    return a.post(prefixEndpoint + 'integration/log', payload, headers)
  },
  doResolve(payload) {
    return a.post(prefixEndpoint + `integration/${payload.system}/resolve`, payload.data, headers)
  }
}
